<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__step6">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--step6 is-hidden-mobile"
      :style="`background-image: url(${imgCasalComendoJuntos})`"
    ></div>
    <div
      class="column has-text-centered onboarding-create-site__description onboarding-create-site__description--step6"
    >
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          Agora sobre sua lista de presentes
        </h1>
        <p class="onboarding-create-site__paragraph">
          No Casar.com vocês montam a lista com presentes fictícios e recebem
          tudo em dinheiro, assim vocês possuem mais flexibilidade e podem
          investir no que preferirem.
        </p>
        <div class="onboarding-create-site__shooping">
          <div class="onboarding-create-site__shooping--item">
            <img :src="carIcon" alt="Shopping Casar.com" />
            <p>
              <span class="onboarding-create-site__shooping--tag"
                >EXCLUSIVO</span
              ><br /><span>Comprar produtos no Shopping Casar.com</span>
              ganhando 4% de cashback.
            </p>
          </div>
          <div class="onboarding-create-site__shooping--division">
            <div />
            <p><span>e/ou</span></p>
            <div />
          </div>
          <div class="onboarding-create-site__shooping--item">
            <img :src="moneyIcon" alt="Carteira Casar.com" />
            <p>
              <span>Transferir gratuitamente para sua conta</span> bancária
              inclusive os cashbacks.
            </p>
          </div>
        </div>
      </div>
      <buttonsNext :stepNumber="stepNumber" :btnJumpInvisible="true" />
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

import buttonsNext from '@/components/OnboardingCreationSite/ButtonsNext.vue'
import imgCasalComendoJuntos from '@/assets/img/onboarding-create-site/casal-comendo-juntos.jpg'

import carIcon from '@/assets/img/onboarding-create-site/icon/car.svg'
import moneyIcon from '@/assets/img/onboarding-create-site/icon/money.svg'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    buttonsNext,
  },

  props: {
    stepNumber: Number,
  },

  data() {
    return {
      imgCasalComendoJuntos,
      carIcon,
      moneyIcon,
    }
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__step6 {
    display: flex;
    min-height: fit-content;
  }

  &__img {
    &--step6 {
      margin-top: 12px;
    }
  }

  &__description {
    &--width-80 {
      align-items: center;
    }

    &--step6 {
      min-height: calc(100vh - 56px);
    }
  }

  &__shooping {
    border: 1px solid #dee7ea;
    border-radius: 8px;
    max-width: 472px;
    margin-bottom: 45px;
    margin-top: 25px;

    &--tag {
      width: 62px;
      padding: 4px;
      border-radius: 4px;
      background-color: $primary;
      font-size: 10px;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #fff;
      height: 20px;
    }

    &--item {
      display: flex;
      text-align: left;
      padding: 32px 36px;

      img {
        margin-right: 15px;
      }

      p {
        font-size: 16px;
        line-height: 1.25;
        color: $neutraldarkest;

        span {
          font-weight: bold;
        }
      }
    }

    &--division {
      p {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #dee7ea;
        font-size: 14px;
        line-height: 0.1em;

        span {
          background: #fff;
          padding: 0 10px;
        }
      }
    }
  }
}
</style>
